import { NgModule } from '@angular/core';
import {
  DynamicCoachingComponent,
  DynamicCommentComponent,
  DynamicLastModifiedComponent,
  DynamicReviewComponent,
} from './components';
import { CommonModule } from '@angular/common';
import { UtilsModule } from '@progress/kendo-angular-utils';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import {
  provideNgxMask,
  NgxMaskDirective,
  NgxMaskPipe,
} from 'ngx-mask';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { DashboardLayoutModule } from '@syncfusion/ej2-angular-layouts';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ChartModule } from '@progress/kendo-angular-charts';
import { UIModule } from '@ups/xplat/web/features';
import { DynamicRenderComponentsModule } from '@ups/xplat/web/forms/dynamic-render';
import { PlatformDynamicComponentsToken } from '@ups/xplat/dynamic-render';
import { DYNAMIC_COMPONENT_MAPPING } from './component-mapping';

export const DYNAMIC_ITEM_SAFETY_COMPONENTS = [
  DynamicCoachingComponent,
  DynamicReviewComponent,
  DynamicCommentComponent,
  DynamicLastModifiedComponent,
];

const MODULES = [
  CommonModule,
  UIModule,
  UtilsModule,
  DashboardLayoutModule,
  DragDropModule,
  ChartModule,
  InputsModule,
  DateInputsModule,
  NgxMaskDirective,
  NgxMaskPipe,
  AccordionModule,
  DynamicRenderComponentsModule,
];

@NgModule({
  declarations: [...DYNAMIC_ITEM_SAFETY_COMPONENTS],
  exports: [...DYNAMIC_ITEM_SAFETY_COMPONENTS, ...MODULES],
  imports: [...MODULES],
  providers: [
    provideNgxMask(),
    {
      provide: PlatformDynamicComponentsToken,
      useValue: DYNAMIC_COMPONENT_MAPPING,
      multi: true,
    },
  ],
})
export class DynamicRenderSafetyComponentsModule {}
